<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 보고서 개요 -->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('보고서 개요') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('지원청') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>{{ $t('설립') }}</div>
          <div class="flex-1">
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="group1" vs-value="공립(병설)" class="mr-2">{{ $t('공립(병설)') }}</vs-radio>
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="group1" vs-value="사립" class="mr-2">{{ $t('사립') }}</vs-radio>
            <vs-radio v-model="form.inputA_2" :disabled="board.readonly" vs-name="group1" vs-value="기관">{{ $t('기관') }}</vs-radio>
          </div>
        </div>
        <div>
          <div>{{ $t('점검일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>

        <div>
          <div>{{ $t('점검자') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_4"/>
        </div>
        <div>
          <div>{{ $t('위탁여부') }}</div>
          <div class="flex-1">
            <vs-radio v-model="form.inputA_5" :disabled="board.readonly" vs-name="group2" vs-value="자체" class="mr-2">{{ $t('자체') }}</vs-radio>
            <vs-radio v-model="form.inputA_5" :disabled="board.readonly" vs-name="group2" vs-value="컨설팅업체명">{{ $t('컨설팅업체명') }}</vs-radio>
          </div>
        </div>
        <div>
          <div>{{ $t('위탁내용') }}</div>
          <div class="flex-1">
            <vs-radio v-model="form.inputA_6" :disabled="board.readonly" vs-name="group3" vs-value="월점검" class="mr-2">{{ $t('월점검') }}</vs-radio>
            <vs-radio v-model="form.inputA_6" :disabled="board.readonly" vs-name="group3" vs-value="위험성평가" class="mr-2">{{ $t('위험성평가') }}</vs-radio>
            <vs-radio v-model="form.inputA_6" :disabled="board.readonly" vs-name="group3" vs-value="근골격계조사">{{ $t('근골격계조사') }}</vs-radio>
          </div>
        </div>
      </div>
    </div>

<!--    근로자 및 산업재해 현황-->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('근로자 및 산업재해 현황') }}</h5>
      <span style="font-weight: 700;">{{ $t('현업근로자') }}</span>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('조리') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>{{ $t('시설관리') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>
        <div>
          <div>{{ $t('청소') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div>
          <div>{{ $t('통학차량보조') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
      </div>

      <span style="font-weight: 700;">{{ $t('도급종사자') }}</span>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('조리') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_1" />
        </div>
        <div>
          <div>{{ $t('시설관리') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_2" />
        </div>
        <div>
          <div>{{ $t('청소') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_3" />
        </div>
        <div>
          <div>{{ $t('통학차량보조') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputC_4" />
        </div>
      </div>

      <span style="font-weight: 700;">{{ $t('전년도') }}</span>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('사망') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_1" />
        </div>
        <div>
          <div>{{ $t('부상') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_2" />
        </div>
        <div>
          <div>{{ $t('질병') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputD_3" />
        </div>
      </div>

      <span style="font-weight: 700;">{{ $t('당해년도') }}</span>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('사망') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputE_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_1" />
        </div>
        <div>
          <div>{{ $t('부상') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputE_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_2" />
        </div>
        <div>
          <div>{{ $t('질병') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputE_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputE_3" />
        </div>
      </div>
    </div>

<!--    최근 3년이내 산업재해 발생 내용-->
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('최근 3년이내 산업재해 발생 내용') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('발생일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputF_1" />
        </div>
        <div>
          <div>{{ $t('직종') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputF_2" />
        </div>
        <div>
          <div>{{ $t('재해유형') }}</div>
          <p v-if="isPrint" class=" print-input flex-1">{{ form.inputF_3 }}</p>
          <disaster-class-selector
            v-else
            class="w-full flex-1"
            :readonly="board.readonly"
            v-model="form.inputF_3"
          />
        </div>

        <div>
          <div>{{ $t('상해종류') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputF_4" />
        </div>
        <div>
          <div>{{ $t('발생개요') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputF_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputF_5" />
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t('점검결과 총평') }}</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>{{ $t('주요 지도사항') }}</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputG_1 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputG_1" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 점검표 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="점검표"
      :table-header-title="'점검사항'"
      :table-header-check="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '비고' },]"
      contentBefore="•"
      v-model="form.inspectList"
      class="mt-5"
    >
      <template #customType="{ trData, id, input }">
        <div v-if="trData && trData.customType === '1'" class="p-2">
          <div class="flex justify-between items-center">
            <span>{{ $t('실시일') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
            <date-selector v-else :readonly="board.readonly" v-model="trData.input1" style="min-width: 200px;"/>
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>{{ $t('실시일') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input2 }}</p>
            <date-selector v-else :readonly="board.readonly" v-model="trData.input2" style="min-width: 200px;"/>
          </div>
        </div>
        <div v-else-if="trData && trData.customType === '2'" class="p-2">
          <div class="flex justify-between items-center">
            <span>{{ $t('교육대상') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input1" />
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>{{ $t('실시인원') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input2 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input2" />
          </div>
        </div>
        <div v-else-if="trData && trData.customType === '3'" class="p-2">
          <div class="flex justify-between items-center mt-1">
            <span>{{ $t('실시일') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input1 }}</p>
            <date-selector v-else :readonly="board.readonly" v-model="trData.input1" style="min-width: 200px;"/>
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>{{ $t('개선사항') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input2 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input2" />
          </div>
          <div class="flex justify-between items-center mt-1">
            <span>{{ $t('조치사항') }}</span>
            <p v-if="isPrint" class="print-input flex-1">{{ trData.input3 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="trData.input3" />
          </div>
        </div>
      </template>
    </table-inspect-merge>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="관리적요인 개선조치 요구사항"
      :tableData="[
        { id: 'cell1', title: '개선조치 보고사항', type: 'text', placeholder: '내용' },
        { id: 'cell2', title: '자체개선/조치보고', type: 'text', placeholder: '내용', width: '280px' },
      ]"
      v-model="form.requirementList"
    />


    <!-- 확인자 -->
    <div v-if="!isPrint" class="mt-28px">
      <div>
        <h5><i class="dot"></i>{{ $t('결재란') }}</h5>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>{{ $t('작성자') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>{{ $t('검토자') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>{{ $t('회람자') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer mt-4" style="align-items: start">
        <div>
          <div>{{ $t('승인자') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign4.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign4.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign4.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign4.sign" :src="form.sign4.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import * as inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import Print from "@/views/boards/single-page/669/Print.vue";

export default {
  components: {
    Print,
    TableCustom,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",

        inputF_1: "",
        inputF_2: "",
        inputF_3: "",
        inputF_4: "",
        inputF_5: "",

        inputG_1: "",

        inspectList: inspectData.inspectTable,
        requirementList: [ { "id": 1, "cell1": "", "cell2": "" } ],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
